// extracted by mini-css-extract-plugin
export default {"search":"SearchBar_search__P8HDW","srOnly":"SearchBar_srOnly__gqgBY"};